// @flow

import type {MarkdocTagRegistration} from 'docs/markdoc';

export const CardPaymentDemoOxxo: MarkdocTagRegistration = {
  tag: 'card-payment-demo-oxxo',
  component: 'CardPaymentDemoOxxo',
};
